const getDefaultState = () => {
    return {
        effectiveTexts: {},
    }
}

const state = getDefaultState()

const getters = {
    effectiveTexts(state: any) {
        return state.effectiveTexts
    },
}

const mutations = {
    effectiveTexts(state: any, payload: any) {
        state.effectiveTexts = payload
    },

    //RESET
    resetEffectiveTexts(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
